module.exports = __webpack_public_path__ + "img/print.69a83a50.svg";